module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-voxi-bottom-01.1@2x.cf9560b0.jpg";